import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Welcome } from 'src/app/model/home/welcome';
import { Amount } from 'src/app/model/home/year';
import { HomeService } from 'src/app/services/http/home/home.service';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';
registerLocaleData(localeFr, 'fr');

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
  
  constructor(private service: HomeService, private installationService : InstallationsService, private router : Router) { }

  public displayedMonth!: any;
  public pizzadoor!: any;
  public panidoor!: any;
  public stats!: Welcome;
  public years!: Amount[];

  ngOnInit(): void {
    this.service.getHomeData()
              .subscribe( 
                (stats) => {
                  this.stats = stats
                });

    this.service.getTotalSalesTwoYears()
              .subscribe( 
                (years) => {
                  this.years = years;
                });

    this.installationService.getRates()
    .subscribe( (rates) => {
        let currentMonth = new Date().getMonth();

        let previousMonth = 11;
        if( currentMonth > 0 ){
          previousMonth = currentMonth - 1;
          this.pizzadoor = rates['pizzadoor'].find((element: any) => element.month == currentMonth).installs;
          this.panidoor = rates['panidoor'].find((element: any) => element.month == currentMonth).installs;
        } else{
          // #95 - here we are in january, we want to show numbers for december
          this.pizzadoor = rates['pizzadoor'].find((element: any) => element.month == 12).installs;
          this.panidoor = rates['panidoor'].find((element: any) => element.month == 12).installs;
        }
        
        /** Show the previous month name */
        this.displayedMonth = new Date(new Date().getFullYear(), previousMonth, 1).toLocaleString('default', { month: 'long' });
      });
  }


   getDetailPage(id : number) {
    this.router.navigate(['installation', id]);
  }


}
